import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** ENG-5610: proof that this browser completed a verification. Sent as a header rather than a
 *  cookie, because a cookie would have to travel with credentials and a browser refuses a
 *  credentialed response whose Access-Control-Allow-Origin is "*". See order/device_tokens.py. */
export const DEVICE_TOKEN_KEY = 'lb_device_token';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Token ${environment.accessToken}`
        }
      });
    }

    // Only to our own API. Other hosts (CardConnect, Firebase) must never receive it.
    if (request.url.startsWith(environment.orderApiBackend)) {
      let deviceToken: string = null;
      try {
        deviceToken = localStorage.getItem(DEVICE_TOKEN_KEY);
      } catch (e) {
        // private window or blocked storage: the guest just verifies again
      }
      if (deviceToken) {
        request = request.clone({ setHeaders: { 'X-Device-Token': deviceToken } });
      }
    }

    return next.handle(request);
  }
}
